import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "datatables.net";
import "datatables.net-bs5";
import "datatables.net-select-dt";
import "datatables.net-responsive-dt";
import "../../Destination/custom.css"; // Adjust path as necessary

const MerchantStatus = () => {
  const tableRef = useRef(null);
  const [showForm, setShowForm] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);

  const [statuses, setStatuses] = useState([
    { status: "Active", id: 1 },
    { status: "Suspended", id: 2 },
    { status: "Deactivated", id: 3 },
    { status: "Verified", id: 4 },
    { status: "Pending", id: 5 },
    { status: "Rejected", id: 6 },
  ]);

  const [formData, setFormData] = useState({
    status: "",
  });

  useEffect(() => {
    if (tableRef.current) {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
      $(tableRef.current).DataTable({
        responsive: true,
        paging: true,
        searching: true,
        info: true,
      });
    }
  }, [statuses]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedStatus) {
      setStatuses(
        statuses.map((s) =>
          s.id === selectedStatus.id ? { ...formData, id: s.id } : s
        )
      );
    } else {
      setStatuses([
        ...statuses,
        {
          ...formData,
          id: statuses.length ? statuses[statuses.length - 1].id + 1 : 1,
        },
      ]);
    }
    setShowForm(false);
    setFormData({ status: "" });
    setSelectedStatus(null);
  };

  const handleEdit = (statusObj) => {
    setSelectedStatus(statusObj);
    setFormData({ status: statusObj.status });
    setShowForm(true);
  };

  const handleAddClick = () => {
    setSelectedStatus(null);
    setFormData({ status: "" });
    setShowForm(true);
  };

  return (
    <div className="merchant-status-list d-flex" style={{ gap: "1rem", padding: "1rem" }}>
      {/* Left side form box */}
      {showForm && (
        <div
          className="form-box card"
          style={{
            width: "300px",
            padding: "1rem",
            border: "1px solid #ddd",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          }}
        >
          <h2>{selectedStatus ? "Edit Status" : "Add Status"}</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label>Status:</label>
              <input
                type="text"
                name="status"
                value={formData.status}
                onChange={handleChange}
                required
                className="form-control"
              />
            </div>
            <button type="submit" className="btn btn-success me-2">
              Save
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowForm(false)}
            >
              Cancel
            </button>
          </form>
        </div>
      )}

      {/* Right side table */}
      <div className="table-container flex-grow-1">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h1>Merchant Statuses</h1>
            <button className="btn btn-md btn-primary" onClick={handleAddClick}>
              Add Status
            </button>
          </div>
          <div className="card-body">
            <table
              ref={tableRef}
              className="table table-bordered display"
              style={{ width: "100%" }}
            >
              <thead>
                <tr>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {statuses.map((s) => (
                  <tr key={s.id}>
                    <td>
                      <span className="badge bg-secondary">{s.status}</span>
                    </td>
                    <td>
                      <button
                        className="btn btn-warning btn-sm"
                        onClick={() => handleEdit(s)}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MerchantStatus;
